import { useState, useRef, useEffect } from 'react';
import { useReducedMotion } from '@mantine/hooks';
function useLockScroll(_ref) {
  let {
    opened,
    transitionDuration
  } = _ref;
  const [shouldLockScroll, setShouldLockScroll] = useState(opened);
  const timeout = useRef();
  const reduceMotion = useReducedMotion();
  const _transitionDuration = reduceMotion ? 0 : transitionDuration;
  useEffect(() => {
    if (opened) {
      setShouldLockScroll(true);
      window.clearTimeout(timeout.current);
    } else if (_transitionDuration === 0) {
      setShouldLockScroll(false);
    } else {
      timeout.current = window.setTimeout(() => setShouldLockScroll(false), _transitionDuration);
    }
    return () => window.clearTimeout(timeout.current);
  }, [opened, _transitionDuration]);
  return shouldLockScroll;
}
export { useLockScroll };